import { createContext, useContext, useMemo } from 'react'
import { Workflow, type WorkflowData } from '@terros/common'
import { type GetHookResponse } from '../hooks'

export type WorkflowContextType = Omit<GetHookResponse<WorkflowData>, 'data'> & {
  workflow: Workflow
}

export type LoadedWorkflow = Omit<GetHookResponse<WorkflowData>, 'data'> & {
  data: WorkflowData
}

export const WorkflowContext = createContext<WorkflowContextType | undefined>(undefined)

export const useCurrentWorkflow = (): WorkflowContextType => {
  const context = useContext(WorkflowContext)
  if (!context) throw new Error('No WorkflowContext')
  return context
}

export const useSafeCurrentWorkflow = (): WorkflowContextType | undefined => {
  const context = useContext(WorkflowContext)
  if (!context) return undefined
  return context
}

export const useWorkflowContextValue = (props: LoadedWorkflow): WorkflowContextType => {
  const { data: workflow } = props
  const workflowInstance = useMemo(() => new Workflow(workflow), [workflow])
  return { ...props, workflow: workflowInstance }
}
